<template>
	<div class="prod_info" v-if="obj_to_null(this.product)">
		<info_field
            f_uniq="cprice"
            @update_categ="change_atr"
            :f_title="__t('PRICE')"
            f_type="price"
            :is_disabled="is_disabled"
            f_icon="fa-sack-dollar"
            :f_val="product.price.toString()">
        </info_field>

		<info_field f_uniq="cinprice" :f_title="__t('MIN_QUAL')" f_icon="fa-sack-dollar" :f_val="product.min_qual.toString()"></info_field>

	</div>
</template>

<script>
import Info_field from "../../../../sys/info_field";
export default {
	name: "product_prices",
	components: {
		Info_field
	},
	props : {
		product : {
			type : Object
		}
	},
    methods :  {
        change_atr(atr_name,atr_val) {
            if(this.product.hasOwnProperty(atr_name)) {
                this.product[atr_name] = atr_val;
            }
        }
    },
    computed : {
        is_disabled () {
            return this.product.id > 0 && parseInt(this.product.provider_id) != 8;
        },

        prov_name() {
            if(this.product.hasOwnProperty("provider")) {
                return this.product.provider.name + " <-- " + this.product.provider.direction;
            }
        }
    },
}
</script>

<style scoped>

</style>
